import React from 'react';
import { WidgetProps } from '@rjsf/utils';
import LabelValue from '../../LabelValue';
import AssigneeSelect from '../../AssigneeSelect/AssigneeSelect';

const AssignedUserWidget = (props: WidgetProps) => {
  const unnassignedAsInt = props.schema?.format_options?.unnassigned_as_int;
  return (
    <div>
      <LabelValue
        sx={{ mb: 1.5, '& .MuiAutocomplete-root': { mt: '-9px', mb: '-14px' } }}
        label={
          <>
            {props.label}
            {props.required ? <strong style={{ color: 'var(--primary-main)', marginLeft: 2, fontSize: '1.1rem' }}>*</strong> : ''}
          </>
        }
      >
        <AssigneeSelect
          hideUnassigned={props.schema.format === 'UserPicker'}
          value={props.value}
          onChange={props.onChange}
          assigns="user"
          unnassignedAsInt={unnassignedAsInt}
        />
      </LabelValue>
    </div>
  );
};

export default AssignedUserWidget;
